import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../lib/auth-client';
import { setGlitchtipUser } from '../lib/glitchtip';

/**
 * Last identity handed to GlitchTip. Module-scoped so the sync below only fires
 * when the session actually changes, rather than on every render.
 */
let syncedUserId: string | null = null;

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  // Attach the signed-in identity to subsequent error reports, so a report says
  // who hit the error instead of "some browser". Cleared on sign-out.
  const userId = session?.user?.id ?? null;
  if (!isPending && userId !== syncedUserId) {
    syncedUserId = userId;
    setGlitchtipUser(
      session?.user ? { id: session.user.id, email: session.user.email } : null
    );
  }

  if (isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading...
      </div>
    );
  }

  if (!session?.user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
